import Record from "./components/Record";
import "bootstrap/dist/css/bootstrap.min.css";
import "./css/main.css";
import { createBrowserHistory, History } from "history";
import configureStore from "./store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { FirebaseAppProvider } from "reactfire";
import { BrowserRouter } from "react-router-dom";
import Auth from "./components/Auth";
import Routing from "./components/Routing";

import Snowfall from "react-snowfall";

export const history: History = createBrowserHistory();
const { store, persistor } = configureStore(history);

const firebaseConfig = {
	apiKey: "AIzaSyAPnJACFJbTpXwnKM3H-6vAB45InjQEgqM",
	authDomain: "polarizingexpress.firebaseapp.com",
	projectId: "polarizingexpress",
	storageBucket: "polarizingexpress.appspot.com",
	messagingSenderId: "198827601629",
	appId: "1:198827601629:web:28c28591eca8e0beb13534",
	measurementId: "${config.measurementId}"
};

function App() {
	return (
		<Provider store={store}>
			<PersistGate loading={null} persistor={persistor}>
				<BrowserRouter>
					<FirebaseAppProvider firebaseConfig={firebaseConfig}>
						<Auth>
							<Routing></Routing>
							<div className="hill-one"></div>
							<div className="hill-two"></div>
							<Snowfall />
						</Auth>
					</FirebaseAppProvider>
				</BrowserRouter>
			</PersistGate>
		</Provider>
	);
}

export default App;
